/**
 * @desc 拉取平台多份报告
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.platDataFlow.PlatformReportRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/synchronousReportList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
